__turbopack_context__.v({
  "nextButton": "NextLink-module-scss-module__nM6Tgq__nextButton",
});
